// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_010dc","icon":"_452bd"};